import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../../firebase';
import useAuth from '../../hooks/useAuth';
import AccountSidebar from './AccountSidebar';
import ProfileTab from './ProfileTab';
import AppointmentsTab from './AppointmentsTab';
import VehiclesTab from './VehiclesTab';
import GiftCardsTab from './GiftCardsTab';

const AccountPage = ({ isMobile }) => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('profile');
  const [userProfile, setUserProfile] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zipCode: ''
  });
  const [loading, setLoading] = useState(true);
  
  // Fetch user profile on component mount
  useEffect(() => {
    if (user) {
      const userProfileRef = ref(database, `users/${user.uid}/profile`);
      const unsubscribe = onValue(userProfileRef, (snapshot) => {
        if (snapshot.exists()) {
          setUserProfile(snapshot.val());
        }
        setLoading(false);
      });
      
      return () => unsubscribe();
    } else {
      setLoading(false);
    }
  }, [user]);
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#3A98B9] mx-auto"></div>
          <p className="mt-3 text-gray-600">Loading your profile...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">My Account</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* Sidebar */}
        <div className="md:col-span-1">
          <AccountSidebar 
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            userProfile={userProfile}
            isMobile={isMobile}
          />
        </div>
        
        {/* Main Content */}
        <div className="md:col-span-3">
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            {activeTab === 'profile' && (
              <ProfileTab 
                userProfile={userProfile}
                userId={user.uid}
                isMobile={isMobile}
              />
            )}
            
            {activeTab === 'appointments' && (
              <AppointmentsTab />
            )}
            
            {activeTab === 'vehicles' && (
              <VehiclesTab 
                userId={user.uid}
                isMobile={isMobile}
              />
            )}
            
            {activeTab === 'gift-cards' && (
              <GiftCardsTab 
                isMobile={isMobile}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;